import LoginView from '../views/auth/LoginView';
import LogoutView from '../views/auth/LogoutView';
import ActiveOrders from '../views/active-orders';
import OrderHistory from '../views/order-history';
import Menu from '../views/menu';
import PrinterSettingsView from '../views/printer-settings/PrinterSettingsView';
import OrderControl from '../views/order-control';
import BusyMode from '../views/busy-mode';

export const RouteEnum = {
  Home: '/',
  OrderHistory: '/order-history',
  Menu: '/menu',
  PrinterSettings: '/printer-settings',
  OrderControl: '/order-control',
  BusyMode: '/busy-mode',
  Login: '/login',
  Logout: '/logout',
};

export default [
  {
    path: RouteEnum.Login,
    component: LoginView,
  },
  {
    path: RouteEnum.Home,
    is_private: true,
    component: ActiveOrders,
  },
  {
    path: RouteEnum.OrderHistory,
    is_private: true,
    component: OrderHistory,
  },
  {
    path: RouteEnum.Menu,
    is_private: true,
    component: Menu,
  },
  {
    path: RouteEnum.PrinterSettings,
    is_private: true,
    component: PrinterSettingsView,
  },
  {
    path: RouteEnum.OrderControl,
    is_private: true,
    component: OrderControl,
  },
  {
    path: RouteEnum.BusyMode,
    is_private: true,
    component: BusyMode,
  },
  {
    path: RouteEnum.Logout,
    is_private: true,
    component: LogoutView,
  },
];
